function rem(px) {
  return `${px / 16}rem`
}

module.exports = {
  content: [
    './app/**/*.tsx',
    './app/**/*.css',
    './components/**/*.tsx',
    './components/**/*.css',
    './lib/**/*.ts',
    './lib/**/*.css',
    './blocks/**/*.tsx',
    './blocks/**/*.css',
  ],
  important: '#__next',
  theme: {
    fontFamily: {},
    fontSize: {
      200: [rem(200), { lineHeight: rem(220) }],
      180: [rem(180), { lineHeight: rem(198) }],
      80: [rem(80), { lineHeight: rem(88) }],
      70: [rem(70), { lineHeight: rem(77) }],
      60: [rem(60), { lineHeight: rem(72) }],
      50: [rem(50), { lineHeight: rem(60) }],
      40: [rem(40), { lineHeight: rem(48) }],
      36: [rem(36), { lineHeight: rem(44) }],
      32: [rem(32), { lineHeight: rem(40) }],
      30: [rem(30), { lineHeight: rem(36) }],
      27: [rem(27), { lineHeight: rem(30) }],
      24: [rem(24), { lineHeight: rem(30) }],
      22: [rem(22), { lineHeight: rem(28) }],
      20: [rem(20), { lineHeight: rem(30) }],
      18: [rem(18), { lineHeight: rem(20) }],
      16: [rem(16), { lineHeight: rem(24) }],
      14: [rem(14), { lineHeight: rem(22) }],
      12: [rem(12), { lineHeight: rem(14) }],
      8: [rem(8), { lineHeight: rem(8) }],
    },
    fontWeight: {
      bold: 'bold',
      medium: 500,
      regular: 'normal',
      light: 300,
    },
    lineHeight: {
      220: rem(220),
      88: rem(88),
      77: rem(77),
      66: rem(66),
      55: rem(55),
      44: rem(44),
      33: rem(33),
      40: rem(40),
      39: rem(39),
      30: rem(30),
      28: rem(28),
      26: rem(26),
      22: rem(22),
      20: rem(20),
      18: rem(18),
      14: rem(14),
    },
    // TODO figure this out...
    letterSpacing: {
      0.1: '0.01em',
      0.3: '0.02em',
      0.7: '0.04em',
      0: '0',
      20: '0.02em',
      32: '0.032em',
      50: '0.05em',
      60: '0.06em',
    },
    colors: {
      black: '#1e1e1e',
      violet: '#be7dff',
      yellow: '#ffc800',
      blue: '#5fd2ff',
      white: '#fff',
      orange: '#ff5000',
      petrol: '#00f0a5',
      red: '#ff0055',
      background: 'var(--background-color, #fff)',
      current: 'currentColor',
      highlight: 'var(--highlight-color, #ff5000)',
      wave: 'var(--wave-color, var(--highlight-color, #ff5000))',
      lightGray: '#A8A8A8',
      darkGray: '#F0F0F0',
      surfaceLight: '#F9F9F9',
      darkBlue: '#0079A2',
      darkPurple: '#823FBD',
      darkYellow: '#957200',
      darkGreen: '#007A58',
      headerCtaBg: 'var(--header-cta-bg, #5FD2FF)',
      headerCtaBorder: 'var(--header-cta-border, #0079A2)',
      headerCtaBgDesktop: 'var(--header-cta-bg-desktop, #5FD2FF)',
      headerCtaBorderDesktop: 'var(--header-cta-border-desktop, #0079A2)',
    },
    spacing: {
      0: '0',
      2: rem(2),
      4: rem(4),
      6: rem(6),
      8: rem(8),
      12: rem(12),
      14: rem(14),
      16: rem(16),
      20: rem(20),
      24: rem(24),
      26: rem(26),
      32: rem(32),
      40: rem(40),
      42: rem(42),
      44: rem(44),
      48: rem(48),
      52: rem(52),
      54: rem(54),
      56: rem(56),
      64: rem(64),
      68: rem(68),
      72: rem(72),
      76: rem(76),
      80: rem(80),
      84: rem(84),
      88: rem(88),
      96: rem(96),
      112: rem(112),
      128: rem(128),
      132: rem(132),
      146: rem(146),
      160: rem(160),
      174: rem(174),
      192: rem(192),
      200: rem(200),
      212: rem(212),
      224: rem(224),
      256: rem(256),
      266: rem(266),
      288: rem(288),
      300: rem(300),
      314: rem(314),
      320: rem(320),
      340: rem(340),
      360: rem(360),
      384: rem(384),
      420: rem(420),
      434: rem(434),
      440: rem(440),
      460: rem(560),
      462: rem(462),
      468: rem(468),
      470: rem(470),
      482: rem(482),
      512: rem(512),
      610: rem(610),
      640: rem(640),
      654: rem(654),
      768: rem(768),
      1344: rem(1344),
    },
    extend: {
      minWidth: (theme) => theme('spacing'),
      maxWidth: (theme) => theme('spacing'),
      minHeight: (theme) => theme('spacing'),
      maxHeight: (theme) => theme('spacing'),
      backgroundColor: {
        transparent: 'transparent',
      },
      gridTemplateColumns: {
        'auto-fit': 'repeat(auto-fit, minmax(0, 1fr))',
      },
      screens: {
        '3xl': '1600px',
      },
    },
  },
  plugins: [],
}
